
import React from 'react';
import { FaExclamationTriangle, FaWhatsapp } from 'react-icons/fa';

import Button from './Button';

function CotizadorError({ error }) {
  return (  
          <div className="d-flex align-items-center justify-content-center" style={{minHeight: '60vh'}}>
            <div className="bg-white rounded-4 border border-2 w-100" style={{maxWidth: '900px'}}>
              <div className="px-4 px-md-5 py-5 text-center">
                <div className="d-inline-flex align-items-center justify-content-center rounded-circle mb-4" style={{width: '72px', height: '72px', backgroundColor: 'var(--color-surface)'}}>
                  <FaExclamationTriangle size={32} color="var(--color-text-muted)" />
                </div>
                <h2 className="fw-bold mb-3" style={{color: 'var(--color-text-dark)'}}>
                  Hubo un error al cargar tu cotización
                </h2>
                <p className="text-muted mb-3">
                {error || 'Lamentablemente no pudimos encontrar una cotización asociada a este enlace.'}
                </p>
                <p className="fw-semibold" style={{color: 'var(--color-text-dark)'}}>
                  Por favor, intente completando el formulario nuevamente. Si el problema persiste contactá a un asesor.
                </p>
                <div className="d-flex flex-column align-items-center gap-3 mt-4">
                  <Button
                    as="a"
                    href="https://wa.me/5491171915132"
                    target="_blank"
                    rel="noopener noreferrer"
                    variant="danger"
                    className="px-4 py-2 d-inline-flex align-items-center gap-2"
                  >
                    <FaWhatsapp />
                    Contacto
                  </Button>
                  <small className="text-muted">
                    O contactate con nosotros llamando al <strong>0810-333-6686</strong>.
                  </small>
                </div>
              </div>
            </div>
          </div>
  );
}

export default CotizadorError;